import React from 'react';
import styles from './roundLogo.module.scss';
import { Byte } from '../../../Assets/Images';

interface IProps {
  onClick?:()=>void
};

const RoundLogo:React.FC<IProps> = ({onClick}) => {
  return (
    <div className={styles.container} onClick={onClick}>
    <img src={Byte} className={styles.image} alt='logo.png'/>
    </div>
  )
}

export default RoundLogo
